import(/* webpackMode: "eager", webpackExports: ["V2HomeScreen"] */ "/app/apps/platform-web/components/v2/screens/V2HomeScreen.tsx");
